"use client";

import type { SupplierEvaluationProject, AssessmentForm } from "../types";

interface Props {
  project: SupplierEvaluationProject;
  assessmentForm: AssessmentForm | null;
  onStartScoring: () => void;
  onAnalyze: () => void;
}

export function Step4Ratings({ project, assessmentForm, onStartScoring, onAnalyze }: Props) {
  const canScore = ["responded", "scored", "analyzed"].includes(project.workflow_state);
  const isScored = ["scored", "analyzed"].includes(project.workflow_state);

  return (
    <div className="diag-card" style={{ gap: "16px" }}>
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
        <div>
          <h3 style={{ margin: 0, fontSize: "15px", fontWeight: 600 }}>My Ratings</h3>
          <p style={{ fontSize: "13px", color: "var(--ink-mute)", marginTop: "2px" }}>
            Score each response based on your on-site observations
          </p>
        </div>
        {!isScored && (
          <button onClick={onStartScoring} disabled={!canScore} style={primaryBtnStyle}>
            {project.workflow_state === "responded" ? "Start Rating →" : "Continue Rating →"}
          </button>
        )}
      </div>

      {isScored ? (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "13px", color: "var(--ink-mute)" }}>
            <span>✅</span>
            Completed {project.auditor_scored_at ? new Date(project.auditor_scored_at).toLocaleString() : ""}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
            <div style={{ padding: "16px", border: "1px solid var(--line)", borderRadius: "10px", textAlign: "center" }}>
              <p style={{ fontSize: "12px", color: "var(--ink-mute)", margin: "0 0 4px" }}>Supplier Score</p>
              <p style={{ fontSize: "28px", fontWeight: 700, margin: 0, color: "var(--ink)" }}>
                {assessmentForm?.scoring_summary?.overall_supplier_score ?? "—"}/100
              </p>
            </div>
            <div style={{ padding: "16px", border: "1px solid var(--line)", borderRadius: "10px", textAlign: "center" }}>
              <p style={{ fontSize: "12px", color: "var(--ink-mute)", margin: "0 0 4px" }}>Auditor Score</p>
              <p style={{ fontSize: "28px", fontWeight: 700, margin: 0, color: "var(--ink)" }}>
                {assessmentForm?.scoring_summary?.overall_company_score ?? "—"}/100
              </p>
            </div>
          </div>
          <button onClick={onAnalyze} style={primaryBtnStyle}>⚡ Generate AI Analysis</button>
        </div>
      ) : (
        <div style={{ textAlign: "center", padding: "40px 0", fontSize: "14px", color: "var(--ink-mute)" }}>
          {canScore
            ? "Supplier has responded. Start rating their answers."
            : "Waiting for the supplier to complete the questionnaire."}
        </div>
      )}
    </div>
  );
}

const primaryBtnStyle: React.CSSProperties = {
  background: "linear-gradient(135deg, var(--indigo), var(--magenta))",
  border: "none", borderRadius: "8px", padding: "10px 16px",
  fontSize: "13px", fontWeight: 600, color: "#fff", cursor: "pointer",
};
